import { type ReactNode } from 'react';

import { Box } from '@mui/material';

// The body region of a shell, below the app bar: fills the remaining height and
// holds the screen's structure (e.g. a sidebar + content area) as children. A
// reusable layout shell.
const Body = ({ children }: { children: ReactNode }) => (
  <Box sx={{ flex: 1, display: 'flex', minHeight: 0, overflow: 'hidden' }}>
    {children}
  </Box>
);

export default Body;
